import '../publicPath';
import { createAuth } from '@jg/auth';
import Preact, { render } from 'preact';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { clientConfig } from '../config';
import { ChromeContent } from '../content';
import resolveHeaderContent from './resolveHeaderContent';
import { State } from './State';
import '../components/CookieConsent/cookieBotConsentCheck';

declare global {
  interface Window {
    __jgChromeContent: ChromeContent;
    jgOnRenderChrome: () => void;

    jg: {
      chrome: {
        refresh: typeof renderChrome;
      };
    };
  }
}

const content = window.__jgChromeContent;

const headerContainer = document.getElementById('jg-chrome-header');
const footerContainer = document.getElementById('jg-chrome-footer');

const auth = createAuth({
  documentOrReq: document,
  authCookieName: clientConfig.authCookieName,
  activeGroupCookieName: clientConfig.authActiveGroupsCookieName,
  refreshAccessTokenUrl: clientConfig.refreshAccessTokenUrl,
});

let state: State = {
  headerVariant: content.headerVariant,
  footerVariant: content.footerVariant,
  brandingColor: null,
  logoImageUrl: null,
  logoImageWidth: null,
  logoImageHeight: null,
  logoLinkUrl: null,
  featuredItemUrl: null,
  featuredItemLabel: null,
  loginLinkUrl: null,
  signUpLinkUrl: null,
};

function renderChrome({
  headerVariant,
  footerVariant,
  ...newState
}: Partial<State> = {}) {
  state = { ...state, ...newState };

  if (headerVariant) {
    if (content.headerContent[headerVariant]) {
      state.headerVariant = headerVariant;
    } else {
      console.warn(
        `JG.FrontEnd.Chrome: No content found for header variant "${headerVariant}", falling back to previous variant "${
          state.headerVariant
        }"`,
      );
    }
  }

  if (footerVariant) {
    if (content.footerContent[footerVariant]) {
      state.footerVariant = footerVariant;
    } else {
      console.warn(
        `JG.FrontEnd.Chrome: No content found for footer variant "${footerVariant}", falling back to previous variant "${
          state.footerVariant
        }"`,
      );
    }
  }

  const headerContent = content.headerContent[state.headerVariant]!;
  const footerContent = content.footerContent[state.footerVariant]!;

  const resolvedHeaderContent = resolveHeaderContent(
    document,
    headerContent,
    state,
  );

  if (headerContainer) {
    render(
      <Header
        content={resolvedHeaderContent}
        auth={auth}
        location={window.location.href}
      />,
      headerContainer,
      headerContainer.firstElementChild || undefined,
    );
  }

  if (footerContainer) {
    render(
      <Footer content={footerContent} />,
      footerContainer,
      footerContainer.firstElementChild || undefined,
    );
  }

  const isDonateEndpoint = window.location.hostname && window.location.hostname.toLowerCase().indexOf("donate.") === 0;

  if (!isDonateEndpoint && !window.Cookiebot) {
    render(
      <script
        id="Cookiebot"
        src="https://consent.cookiebot.com/uc.js"
        data-cbid="b92ba240-82c3-4d0a-8e54-624851e5ad86"
        data-blockingmode="auto"
        type="text/javascript"
      />,
      document.head,
    );
  }
}

renderChrome();

window.jg =
  window.jg && window.jg.chrome
    ? window.jg
    : {
        ...window.jg,
        chrome: {
          refresh: renderChrome,
        },
      };

try {
  if (typeof window.jgOnRenderChrome === 'function') {
    window.jgOnRenderChrome();
  }
} catch (err) {
  console.error(err);
}
